var bittoelatings_g = [{
    rule: "tydsbeheeropstelling:create",
    bitmask: "1",
    blok: 6,
    beskrywing: "Skep van tydsbeheer opstellings",
    groepe: ["tydsbeheeropstelling", "setup"],
},
{
    rule: "tydsbeheeropstelling:read",
    bitmask: "2",
    blok: 6,
    beskrywing: "Lees van tydsbeheer opstellings",
    groepe: ["tydsbeheeropstelling", "setup"],
},
{
    rule: "tydsbeheeropstelling:update",
    bitmask: "4",
    blok: 6,
    beskrywing: "Verander tydsbeheer opstellings",
    groepe: ["tydsbeheeropstelling", "setup"],
},
{
    rule: "tydsbeheeropstelling:delete",
    bitmask: "8",
    blok: 6,
    beskrywing: "Verwyder van tydsbeheer opstellings",
    groepe: ["tydsbeheeropstelling", "setup"],
},
{
    rule: "tydsbeheer:create",
    bitmask: "16",
    blok: 6,
    beskrywing: "Verlof, oortyd, ens. rekords skep",
    groepe: ["tydsbeheer"],
},
{
    rule: "tydsbeheer:read",
    bitmask: "32",
    blok: 6,
    beskrywing: "Verlof, oortyd, ens. rekords lees",
    groepe: ["tydsbeheer"],
},
{
    rule: "tydsbeheer:update",
    bitmask: "64",
    blok: 6,
    beskrywing: "Verlof, oortyd, ens. rekords verander",
    groepe: ["tydsbeheer"],
},
{
    rule: "tydsbeheer:delete",
    bitmask: "128",
    blok: 6,
    beskrywing: "Verlof, oortyd, ens. rekords verwyder",
    groepe: ["tydsbeheer"],
},
{
    rule: "databronne:create",
    bitmask: "256",
    blok: 6,
    beskrywing: "Skep van 'n databron",
    groepe: ["databronne", "setup"]
},
{
    rule: "databronne:read",
    bitmask: "512",
    blok: 6,
    beskrywing: "Lees van databronne",
    groepe: ["databronne", "setup"]
},
{
    rule: "databronne:update",
    bitmask: "1024",
    blok: 6,
    beskrywing: "Verander databronne",
    groepe: ["databronne", "setup"]
},
{
    rule: "databronne:delete",
    bitmask: "2048",
    blok: 6,
    beskrywing: "Verwyder 'n databron",
    groepe: ["databronne", "setup"]
},
{
    rule: "plukbeplanner_teiken:create",
    bitmask: "4096",
    blok: 6,
    beskrywing: "Skep van plukbeplanner teikens",
    groepe: ["plukbeplanner_teiken", "pluk"]
},
{
    rule: "plukbeplanner_teiken:read",
    bitmask: "8192",
    blok: 6,
    beskrywing: "Lees van plukbeplanner teikens",
    groepe: ["plukbeplanner_teiken", "pluk"]
},
{
    rule: "plukbeplanner_teiken:update",
    bitmask: "16384",
    blok: 6,
    beskrywing: "Verander plukbeplanner teikens",
    groepe: ["plukbeplanner_teiken", "pluk"]
},
{
    rule: "plukbeplanner_teiken:delete",
    bitmask: "32768",
    blok: 6,
    beskrywing: "Verwyder van plukbeplanner teikens",
    groepe: ["plukbeplanner_teiken", "pluk"]
},
{
    rule: "plukbeplanner_items:create",
    bitmask: "65536",
    blok: 6,
    beskrywing: "Skep van plukbeplanner items",
    groepe: ["plukbeplanner_items", "pluk"]
},
{
    rule: "plukbeplanner_items:read",
    bitmask: "131072",
    blok: 6,
    beskrywing: "Lees van plukbeplanner items",
    groepe: ["plukbeplanner_items", "pluk"]
},
{
    rule: "plukbeplanner_items:update",
    bitmask: "262144",
    blok: 6,
    beskrywing: "Verander plukbeplanner items",
    groepe: ["plukbeplanner_items", "pluk"]
},
{
    rule: "plukbeplanner_items:delete",
    bitmask: "524288",
    blok: 6,
    beskrywing: "Verwyder van plukbeplanner items",
    groepe: ["plukbeplanner_items", "pluk"]
},
{
    rule: "plukbeplanner_opstellings:update",
    bitmask: "1048576",
    blok: 6,
    beskrywing: "Verander plukbeplanner opstellings",
    groepe: ["plukbeplanner_opstellings", "pluk"]
},
{
    rule: "insidente:create",
    bitmask: "2097152",
    blok: 6,
    beskrywing: "Skep van insidente",
    groepe: ["insidente"]
},
{
    rule: "insidente:read",
    bitmask: "4194304",
    blok: 6,
    beskrywing: "Lees van insidente",
    groepe: ["insidente"]
},
{
    rule: "insidente:update",
    bitmask: "8388608",
    blok: 6,
    beskrywing: "Verander insidente",
    groepe: ["insidente"]
},
{
    rule: "insidente:delete",
    bitmask: "16777216",
    blok: 6,
    beskrywing: "Verwyder van insidente",
    groepe: ["insidente"]
},
{
    rule: "integrasie:create",
    bitmask: "33554432",
    blok: 6,
    beskrywing: "Aktiveer 'n integrasie",
    groepe: ["integrasie", "setup"]
},
{
    rule: "integrasie:read",
    bitmask: "67108864",
    blok: 6,
    beskrywing: "Lees van integrasies",
    groepe: ["integrasie", "setup"]
},
{
    rule: "integrasie:update",
    bitmask: "134217728",
    blok: 6,
    beskrywing: "Verander integrasies",
    groepe: ["integrasie", "setup"]
},
{
    rule: "integrasie:delete",
    bitmask: "268435456",
    blok: 6,
    beskrywing: "Verwyder 'n integrasie",
    groepe: ["integrasie", "setup"]
},
];

export default bittoelatings_g;